import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24326d06")

_pushScopeId("data-v-24326d06")
const _hoisted_1 = {
  key: 0,
  class: "root"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" This is "),
  /*#__PURE__*/_createVNode("b", null, "NOT"),
  /*#__PURE__*/_createTextVNode(" a public facing path. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" If you found this page by accident, or are snooping around, please return to ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("home")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = { class: "links" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Go Home")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Proceed ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_router_view = _resolveComponent("router-view")

  return (!_ctx.isMe)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("p", null, [
          _hoisted_3,
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Button, { to: "/" }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            color: "error",
            to: _ctx.Paths.PRIVATE_EXPENSE,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logEvent()))
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode(_component_router_view)
      ]))
    : _createCommentVNode("", true)
})